import { z } from 'zod'
import { Currency } from '~library/enums'
import { enumWithEmpty } from '~library/models'

export const travelAmountStatisticsGetFlownAmountSchema = z.object({
  /** 幣別 */
  currency: enumWithEmpty(Currency),
  /** 總金額 */
  amount: z.number(),
  /** 起始日期 */
  startTime: z.string(),
  /** 截止日期 */
  endTime: z.string()
})

export interface TravelAmountStatisticsGetFlownAmount
  extends z.infer<typeof travelAmountStatisticsGetFlownAmountSchema> {}

export class TravelAmountStatisticsGetFlownAmount {
  constructor() {
    return {
      currency: '',
      amount: 0,
      startTime: '',
      endTime: ''
    }
  }
}
